<template>
  <form ref="form">
    <div class="row justify-content-md-center">
      <div class="col-xl-3"></div>
      <div class="col-xl-6 col-center">
        <section class="container-fluid white-box">
          <div class="row">
            <div class="col-md-12">
              <h2>Tell us about your business!</h2>
              <p class="sub-text">
                Who are you and what is the best way to contact you?
              </p>
            </div>
            <div class="col-sm-6 form-group">
              <input
                v-model="fields.first_name"
                required
                type="firstname"
                class="form-control"
                id="first-name"
                aria-describedby="first-name"
                placeholder="First Name"
              />
            </div>
            <div class="col-sm-6 form-group">
              <input
                v-model="fields.last_name"
                required
                type="lastname"
                class="form-control"
                id="last-name"
                aria-describedby="last-name"
                placeholder="Last Name"
              />
            </div>
            <div class="col-md-12 form-group">
              <input
                v-model="fields.email"
                required
                type="email"
                class="form-control"
                id="owner-email"
                aria-describedby="ownerEmail"
                placeholder="Email"
              />
            </div>
            <div class="col-md-12 form-group">
              <input
                v-model="fields.phone"
                required
                type="text"
                class="form-control"
                id="owner-phonenumber"
                aria-describedby="phoneNumber"
                placeholder="Phone Number"
              />
            </div>
            <div class="col-md-12 form-group">
              <input
                v-model="fields.location_name"
                required
                type="text"
                class="form-control"
                id="location_name"
                placeholder="Location Name"
              />
            </div>
          </div>
        </section>

        <section class="container-fluid white-box agreement mt-4">
          <div class="row">
            <TermsOfService />
            <br />
            <AgreementText />
          </div>
          <!-- Sign Fields-->
          <div class="row d-flex justify-content-between">
            <div class="col-sm-8 form-group">
              <input
                v-model="fields.signature"
                required
                type="text"
                class="form-control"
                id="city"
                aria-describedby="city"
                placeholder="Sign Full Name"
              />
            </div>
            <div class="col-sm-4 form-group">
              <input
                v-model="fields.date_of_signing"
                required
                type="text"
                class="form-control"
                id="state"
                aria-describedby="state"
                placeholder="Date"
              />
            </div>
          </div>
          <!--Buttons-->
          <div class="row d-flex justify-content-between">
            <div class="col-md-12 d-flex justify-content-end">
              <button
                class="next-button"
                type="button"
                name="next"
                @click="finish"
              >
                <z-saving-spinner :saving="saving"> Finish </z-saving-spinner>
              </button>
            </div>
          </div>
        </section>
      </div>
      <div class="col-xl-3"></div>
    </div>
  </form>
</template>

<script>
import TermsOfService from "@/components/TermsOfService";
import AgreementText from "@/components/AgreementText";
import SignupService from "@/services/ZdashService";
import ZSavingSpinner from "@/components/z-saving-spinner";
import { sleep } from "@/helpers";
import { SECOND } from "@/utils/utils";
import RequestMixin from "@/mixins/RequestMixin";

export default {
  name: "SignupWaitList",
  components: {
    ZSavingSpinner,
    AgreementText,
    TermsOfService,
  },
  mixins: [RequestMixin],
  data() {
    return {
      fields: {
        first_name: undefined,
        last_name: undefined,
        email: undefined,
        phone: undefined,
        location_name: undefined,
        signature: undefined,
        date_of_signing: undefined,
      },
      saving: false,
    };
  },
  methods: {
    async finish() {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.reportValidity();
        return;
      }
      this.saving = true;
      const signupService = new SignupService();
      const request = signupService.toWaitList(this.fields);
      if (!(await this._executeRequest(request))) {
        return;
      }
      await sleep(2 * SECOND);
      this.$router.push("/wait-list/completed/");
    },
  },
};
</script>

<style scoped>
.page-body {
  /*margin-top: calc(75px + (45) * ((100vh - 675px) / (1080 - 675)));*/
  min-height: calc(100vh);
  background-color: #f6f7fb;
  /*overflow-y: scroll;*/
  padding-top: 7vh;
  padding-bottom: 7vh;
}

@media (max-width: 1199.99px) {
  .page-body {
    margin-top: 60px;
    min-height: calc(100vh);
    /*overflow-y: scroll;*/
    padding-left: 8px;
    padding-right: 8px;
  }
}

@media (min-width: 1200px) {
  .col-center {
    max-width: 696px;
  }
}
</style>
